module.exports = "/_next/static/images/main-image-6d36522e48936f006de2dcbe22c73583.png";